import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import { Button, Card, Chip, Stack } from '@mui/material';
import constants from '../../constants';

const stats = [
  {
    label: 'Faster than typing',
    value: '4x',
  },
  {
    label: 'Languages supported',
    value: '100+',
  },
  {
    label: 'Works on sites',
    value: '1000+',
  },
]

const ExpItem = ({ item }) => {
  const { value, label } = item
  return (
    <Box sx={{ textAlign: 'center', mb: { xs: 1, md: 0 } }}>
      <Typography
        sx={{ color: 'secondary.main', mb: { xs: 1, md: 2 }, fontSize: { xs: 34, md: 44 }, fontWeight: 'bold' }}
      >
        {value}
      </Typography>
      <Typography color="text.secondary" variant="h5">
        {label}
      </Typography>
    </Box>
  )
}
const StartedHero = () => {
  const waveformBars = [24, 36, 58, 44, 72, 52, 38, 64, 78, 46, 30, 54]

  return (
    <Box
      id="hero"
      sx={{
        background:
          'radial-gradient(circle at 10% 10%, rgba(32, 178, 107, 0.16), transparent 30rem), linear-gradient(180deg, #FFFFFF 0%, #F7F4EE 100%)',
        position: 'relative',
        pt: { xs: 5, md: 9 },
        pb: { xs: 8, md: 10 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center" sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                textAlign: { xs: 'center', md: 'left' },
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Chip label="Voice-to-text AI for every webpage" color="secondary" sx={{ mb: 2, alignSelf: { xs: 'center', md: 'flex-start' }, fontWeight: 800 }} />
              <Typography
                component="h1"
                sx={{
                  position: 'relative',
                  fontSize: { xs: 40, md: 64 },
                  fontWeight: 800,
                  lineHeight: 1.08,
                  mb: 3,
                  maxWidth: 720,
                }}
              >
                Do not type.
                <br />
                Just speak.
              </Typography>
              <Box sx={{ mb: 4, width: { xs: '100%', md: '82%' } }}>
                <Typography sx={{ color: 'text.secondary', lineHeight: 1.8, fontSize: 17 }}>
                  {
                    "Voice Typing turns rambling speech into clear, polished writing in Gmail, Docs, support tickets, chats, and any site with a text box. Press the microphone, talk naturally, and let your browser keep up with your thoughts."
                  }
                </Typography>
              </Box>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ alignItems: { xs: 'stretch', sm: 'center' } }}>
                <Button color="primary" size="large" variant="contained" href="https://voicetyping.xyz/login">
                    Get Started
                  </Button>
                <Button color="primary" size="large" variant="outlined" href={constants.tutorial}>
                    Watch Video
                  </Button>
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} sx={{ position: 'relative' }}>
            <Card sx={{ p: 2.5, borderRadius: 3, boxShadow: 12, bgcolor: '#171717', color: 'common.white' }}>
              <Stack spacing={2.5}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'error.main' }} />
                  <Typography variant="subtitle2" sx={{ color: 'common.white' }}>REC Voice Typing</Typography>
                </Stack>
                <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.07)' }}>
                  <Typography sx={{ color: 'rgba(255,255,255,0.58)', fontStyle: 'italic' }}>
                    “umm can you write a follow up to Sarah and make it friendly but concise tell her we can ship the draft by Friday”
                  </Typography>
                </Box>
                <Stack direction="row" spacing={0.75} alignItems="center" sx={{ height: 82 }}>
                  {waveformBars.map((height, index) => (
                    <Box key={index} sx={{ width: 9, height, borderRadius: 99, bgcolor: 'secondary.main' }} />
                  ))}
                </Stack>
                <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'common.white', color: 'text.primary' }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Polished output</Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Hi Sarah, quick follow-up: we can ship the draft by Friday. Let me know if you want any changes before then.
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
        <Box sx={{ mt: { xs: 6, md: 8 }, boxShadow: 8, py: 4, px: { xs: 3, md: 7 }, borderRadius: 3, bgcolor: 'common.white', border: (theme) => `1px solid ${theme.palette.divider}` }}>
          <Grid container spacing={2}>
            {stats.map((item) => (
              <Grid key={item.value} item xs={12} md={4}>
                <ExpItem item={item} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  )
}
export default StartedHero;
